<template>
  <div v-if="enabled" class="turnstile">
    <div ref="box" class="turnstile__box" data-test="turnstile"></div>
    <div v-if="error" class="pop-auth__err">{{ error }}</div>
  </div>
</template>

<script>
import { isTurnstileEnabled, removeTurnstile, renderTurnstile, resetTurnstile } from '@/utils/turnstile'

// Cloudflare Turnstile widget of a form: emits `token` when the visitor is verified (the form sends
// it as captchaToken), `expired` when it lapses. Call reset() after every submit, tokens are single-use.
export default {
  name: 'TurnstileWidget',
  props: {
    action: { type: String, required: true }, // signup | login | forgot_password
  },
  data() {
    return { enabled: isTurnstileEnabled(), widgetId: null, error: '' }
  },
  async mounted() {
    if (!this.enabled) {
      this.$emit('token', '')
      return
    }
    try {
      this.widgetId = await renderTurnstile(this.$refs.box, {
        action: this.action,
        onToken: (token) => {
          this.error = ''
          this.$emit('token', token)
        },
        onExpired: () => this.$emit('expired'),
        onError: () => {
          this.error = "The verification didn't load. Reload the page to try again."
          this.$emit('expired')
        },
      })
    } catch (e) {
      console.log(e)
      this.error = "The verification didn't load. Reload the page to try again."
    }
  },
  beforeDestroy() {
    removeTurnstile(this.widgetId)
  },
  methods: {
    reset() {
      this.$emit('expired')
      resetTurnstile(this.widgetId)
    },
  },
}
</script>

<style scoped>
.turnstile { margin-top: var(--auth-gap, 16px); }
.turnstile__box { min-height: 65px; }
</style>
